let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1K0CS")).then(() => parcelRequire('8JOz7'));